{
  "INTEGRATION_APPS": {
    "FETCHING": "Integrationen werden abgerufen",
    "NO_HOOK_CONFIGURED": "Es wurden keine {integrationId} Integrationen in diesem Konto konfiguriert.",
    "HEADER": "Anwendungen",
    "STATUS": {
      "ENABLED": "Aktiviert",
      "DISABLED": "Deaktiviert"
    },
    "CONFIGURE": "Konfigurieren",
    "ADD_BUTTON": "Neuen Hook hinzufügen",
    "DELETE": {
      "TITLE": {
        "INBOX": "Löschen bestätigen",
        "ACCOUNT": "Verbindung trennen"
      },
      "MESSAGE": {
        "INBOX": "Sind Sie sicher, dass Sie das löschen möchten?",
        "ACCOUNT": "Möchten Sie die Verbindung wirklich trennen?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Ja, löschen",
        "ACCOUNT": "Ja, Verbindung trennen"
      },
      "CANCEL_BUTTON_TEXT": "Abbrechen",
      "API": {
        "SUCCESS_MESSAGE": "Hook wurde erfolgreich gelöscht",
        "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot-Server hergestellt werden. Bitte versuchen Sie es später erneut"
      }
    },
    "LIST": {
      "FETCHING": "Hooks werden abgerufen",
      "INBOX": "Posteingang",
      "DELETE": {
        "BUTTON_TEXT": "Löschen"
      },
      "EDIT": {
        "BUTTON_TEXT": "Bearbeiten"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Eingang auswählen",
          "PLACEHOLDER": "Posteingang auswählen"
        },
        "SUBMIT": "Erstellen",
        "CANCEL": "Abbrechen"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrations-Hook erfolgreich hinzugefügt",
        "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot-Server hergestellt werden. Bitte versuchen Sie es später erneut"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Verbinden"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Verbindung trennen"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Rufen Sie Daten von Ihrem eigenen Server ab und zeigen Sie sie in der Seitenleiste der Konversation an. Gibt HTML (in einem Iframe angezeigt) oder JSON (als Schlüssel/Wert-Liste angezeigt) zurück.",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "E-Mails und Webchats mit Ihrem Daktela-Konto synchronisieren.",
      "RETINO": "Retino bringt Ordnung in die Verwaltung von Retouren und Reklamationen.",
      "MAILSHIP": "Mailship ist ein Lager- und Auftragsabwicklungssystem. Rufen Sie Bestellstatus, Sendungsverfolgung und Versanddetails ab.",
      "RAYNET": "Verbinden Sie Ihr Raynet CRM-Konto, um auf Ihre Kundendaten zuzugreifen. Fügen Sie eine Verbindung mit Ihrem Raynet-Benutzernamen und API-Token hinzu."
    },
    "EDIT": {
      "TITLE": "{name} bearbeiten",
      "FORM": {
        "INBOX": {
          "LABEL": "Posteingang auswählen",
          "PLACEHOLDER": "Posteingang auswählen"
        },
        "SUBMIT": "Aktualisieren",
        "CANCEL": "Abbrechen"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrations-Hook erfolgreich aktualisiert",
        "ERROR_MESSAGE": "Verbindung zum Chat-Server fehlgeschlagen, bitte versuchen Sie es später erneut"
      }
    },
    "TEST_CONNECTION": {
      "BUTTON": "Verbindung testen",
      "SUCCESS": "Verbindung erfolgreich",
      "ERROR": "Verbindung fehlgeschlagen. Bitte überprüfen Sie Ihre Zugangsdaten."
    }
  }
}
